import { useSearchParams, Link } from "react-router-dom";

export default function PendingApprovalPage() {
  const [sp] = useSearchParams();
  const email = sp.get("email");

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg, #f5f7fa 0%, #e4ecf7 100%)", padding: 20 }}>
      <div data-testid="pending-approval-page" style={{ maxWidth: 480, width: "100%", background: "white", borderRadius: 8, boxShadow: "0 8px 32px rgba(0,0,0,0.1)", overflow: "hidden" }}>
        <div style={{ background: "linear-gradient(135deg, #ff9800, #ff6f00)", color: "white", padding: "20px 24px", textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 6 }}>⏳</div>
          <div style={{ fontSize: 18, fontWeight: 700 }}>Richiesta inviata</div>
        </div>
        <div style={{ padding: 28, fontSize: 13, color: "#444", lineHeight: 1.55 }}>
          <p style={{ marginTop: 0 }}>
            Grazie{email && <span> <b>{email}</b></span>}, la tua richiesta di accesso a <b>canossaHUB</b> è stata registrata.
          </p>
          <p>
            Un amministratore valuterà la tua richiesta e, una volta approvata, riceverai accesso all'app.
            Puoi riprovare ad accedere con Google più tardi.
          </p>
          <div style={{ display: "flex", gap: 10, marginTop: 22 }}>
            <Link data-testid="btn-back-home" to="/" style={{ flex: 1, textAlign: "center", padding: "10px 14px", background: "#0066cc", color: "white", textDecoration: "none", borderRadius: 2, fontWeight: 600, fontSize: 12 }}>Torna alla home</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
